<div class="dashboard-informative-pages">
  <dashboard-informative-pages-template [selectedLanguage]="selectedLanguage" [supportedLanguages]="supportedLanguages">
  </dashboard-informative-pages-template>
</div>
